(function () {
  angular
    .module('MktzapApp.Controllers')
    .requires
    .push(
      'ngTable'
    );
  angular.module('MktzapApp.Controllers')
    .controller('ReportsSMSReceivedController', reports);
  reports.$inject = ['$scope', '$http', '$timeout', 'ngTableParams', 'LangService', 'NotificationService', '$rootScope', 'SMSService'];
  function reports ($scope, $http, $timeout, ngTableParams, LangService, NotificationService, $rootScope, SMSService) {
    var vm = this;

    LangService
      .getPageLabels({ 'page': 'menu.reports.smsreceived' })
      .$promise
      .then(function (data) {
        vm.labels = data.lang;
        var options = function () {
          return {
            hAxis: {
              title: vm.labels.hours,
              maxValue: 24
            },
            vAxis: {
              title: vm.labels.smsQuantity,
              minValue: 0,
              maxValue: 4,
              format: '#',
              viewWindow: { min: 0 }
            },
            width: 1100,
            legend: {
              position: 'top'
            }
          };
        }
        var columnChart = {};
        columnChart.type = 'ColumnChart';
        columnChart.options = options();
      });

    $scope.vm = vm;
    vm.loading = false;
    vm.filters = {
      fromDate: moment().startOf('month').format('DD/MM/YYYY'),
      toDate: moment().endOf('month').format('DD/MM/YYYY'),
      channel_id: '0'
    };

    vm.dateSelected = function (type, date) {
      if (type == 'from') {
        vm.pkadayToDate.setMinDate(date);
      }
      if (type == 'to') {
        vm.pkadayFromDate.setMaxDate(date);
      }
    };

    if ($rootScope.checkMenuAccess('reports.smsReceived.showAllChannels')) {
      SMSService.getAllChannels()
        .$promise
        .then(function (data) {
          vm.channels = data;
        })
        .catch(function (error) {
          NotificationService.errorHandler(error, vm.labels.errorLoadUsers)
        })
    }

    vm.countMessages = function (lines) {
      var sum = 0;
      for (var i = 0; i < lines.length; i++) {
        if (lines[i][1] !== '-') {
          sum += parseInt(lines[i][1]);
        }
      }
      return sum;
    };

    vm.download = function (isSearch) {
      if (vm.filters.channel_id == 0) {
        $scope.classTable = 'allChannels';
      } else {
        $scope.classTable = '';
      }
      vm.columnChartObject = null;
      $http.get(apiUrl + '/reports/sms_received', {
        params: {
          filters: vm.filters
        }
      })
        .then(function ({ data, status, headers, config }) {
          if (isSearch) {
            if (data.success === false) {
              NotificationService.errorHandler(data, data.error_message);
              return false;
            }
            var allTextLines = data.split(/\r\n|\n/);
            var headers = allTextLines[1].split(',');
            var header = [];
            for (var x = 0; x < headers.length; x++) {
              header.push(headers[x].replace(/["]/g, ''));
            }
            var lines = [];
            for (var i = 0; i < allTextLines.length; i++) {
              if (i > 1) {
                var data = allTextLines[i].split(',');
                if (data.length == header.length) {
                  var tarr = [];
                  for (var j = 0; j < header.length; j++) {
                    tarr.push(data[j].replace(/["]/g, ''));
                  }
                  lines.push(tarr);
                }
              }
            }
            var sum = vm.countMessages(lines);
            if (sum === 0) {
              vm.result = 'no_messages';
            } else {
              vm.result = lines.length;
              vm.sum = sum;
            }
            vm.headers = header;
            vm.data = lines;
          } else {
            if (data.success === false) {
              NotificationService.errorHandler(data, data.error_message);
              return false;
            }

            var filename = headers('Mktzap-Filename') || vm.labels.reportName;

            var anchor = angular.element('<a/>');
            anchor.css({ display: 'none' }); // Make sure it's not visible
            angular.element(document.body).append(anchor); // Attach to document

            var blob = new Blob([data], { type: 'text/csv' });
            var csvUrl = URL.createObjectURL(blob);

            anchor.attr({
              href: csvUrl,
              target: '_self',
              download: filename
            })[0].click();

            anchor.remove(); // Clean it up afterwards
            URL.revokeObjectURL(csvUrl); // Clean memory blob
          }
        }, function ({ data, status, headers, config }) {
          NotificationService.errorHandler(data, vm.labels.errorReport);
        })
    };

    vm.showChart = function (lines) {
      if (lines[1] === '-') {
        vm.columnChartObject = null;
        return;
      }

      $http.get(apiUrl + '/reports/sms_received/by_hour', {
        params: {
          date: lines[0],
          channel_id: vm.filters.channel_id
        }
      })
        .then(function ({ data, status, headers, config }) {
          var columnData = { cols: [
            { id: 't', label: vm.labels.hours, type: 'string' },
            { id: 's', label: vm.labels.smsMessages, type: 'number' }
          ],
          rows: [] };
          angular.forEach(data, function (value, key) {
            columnData.rows.push({ c: [
              { v: key + 'h' },
              { v: parseInt(value) }
            ] });
          });
          columnChart.data = columnData;
          vm.columnChartObject = columnChart;
          vm.columnChartTitle = lines[0];
        }, function ({ data, status, headers, config }) {
          NotificationService.errorHandler(data, vm.labels.errorGenerateGraph);
        })
    };
  }
})();
